import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import { useTranslation } from '../../../../../../i18n/hooks/useTranslation';
import { ATS_CV_WIZARD_LAST_INDEX } from '../engines/atsCvWizardSteps.js';
import '@/styles/ats-cv-wizard.scss';

/**
 * Step navigation for the CV wizard.
 *
 * Download, print and clear used to sit here too; they are the tool's actions
 * rather than the form's, so they moved into the sticky action bar every other
 * tool has at the foot of the screen. What is left is the pair that only means
 * anything next to the fields.
 */
export default function AtsCvFormFooter({ activeStep, onNext, onPrev }) {
    const { t } = useTranslation();
    const isFirst = activeStep === 0;
    const isLast = activeStep === ATS_CV_WIZARD_LAST_INDEX;

    return (
        <div className="ats-cv-form-footer">
            <div className="ats-cv-form-footer__row">
                <button
                    type="button"
                    className="ats-cv-form-footer__btn ats-cv-form-footer__btn--secondary"
                    onClick={onPrev}
                    disabled={isFirst}
                >
                    <IconChevronLeft size={11} aria-hidden />
                    <span>{t('atsCvMaker.footer.prev')}</span>
                </button>
                <button
                    type="button"
                    className="ats-cv-form-footer__btn ats-cv-form-footer__btn--primary"
                    onClick={onNext}
                >
                    <span>{isLast ? t('atsCvMaker.footer.viewPreview') : t('atsCvMaker.footer.next')}</span>
                    {!isLast ? <IconChevronRight size={11} aria-hidden /> : null}
                </button>
            </div>
        </div>
    );
}
